import { useTranslation } from 'react-i18next';

type Props = unknown;

export const ShareDisabledMessage: React.FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <div className="my-2 rounded-lg border border-red-500 bg-red-200 p-4">
      {t('canvas.viewModelSetting.shareDisabledLine1')}
      <br />
      {t('canvas.viewModelSetting.shareDisabledLine2')}
    </div>
  );
};
